<app-standard-page-content [limitWidth]="true" [wide]="true">
  <app-standard-page-content-grid>
    @if (reports && reports.length > 0) {
      <table class="table">
        <thead>
          <tr>
            <th scope="col">Title</th>
            <th scope="col">Created</th>
            <th scope="col">Status</th>
            <th class="text-end" scope="col"></th>
          </tr>
        </thead>
        <tbody>
          @for (report of reports; track report; let i = $index) {
            <tr>
              <td scope="row">
                @if (reportComplete(report)) {
                  <button
                    type="button"
                    class="btn btn-link p-0"
                    (click)="downloadReport(report)"
                  >
                    @switch (report.contentType) {
                      @case ('application/zip') {
                        <span class="badge bg-warning">ZIP</span>
                      }
                      @case ('application/vnd.ms-excel') {
                        <span class="badge bg-success">XLSX</span>
                      }
                      @case ('text/csv') {
                        <span class="badge bg-success">CSV</span>
                      }
                      @case ('application/pdf') {
                        <span class="badge bg-danger">PDF</span>
                      }
                    }

                    {{ report.title }}
                  </button>
                  <div type="button" class="small text-body-secondary">
                    Download expires {{ report.expires | amTimeAgo }}
                  </div>
                } @else {
                  <div class="text-body-secondary">
                    <em>{{ report.title }}</em>
                  </div>
                  @if (showLoading(report.status)) {
                    <div class="bg-light">
                      <div
                        class="bg-tertiary mt-1 mb-2"
                        style="transition: width 0.5s ease; height: 0.5rem"
                        [style.width]="100 * report.progress + '%'"
                      ></div>
                    </div>
                  }
                }
              </td>
              <td>
                {{ formatDate(report.created) }}
              </td>
              <td>
                {{ getReportStatus(report.status) }}
                @if (report.status === ReportRequestStatus.InProgress) {
                  <span> - {{ report.progress || 0 | aapercent }} </span>
                }
              </td>
              <td class="text-end">
                @if (reportComplete(report)) {
                  <button
                    type="button"
                    class="btn btn-link"
                    aria-label="Download"
                    ngbTooltip="Download"
                    (click)="downloadReport(report)"
                  >
                    <i-lucide name="download"></i-lucide>
                  </button>
                }
              </td>
            </tr>
          }
        </tbody>
      </table>
    } @else {
      @if (reports && reports.length === 0) {
        <div>
          <p>There are currently no reports to display.</p>
        </div>
      }
    }
  </app-standard-page-content-grid>
</app-standard-page-content>

<app-side-panel #sidePanel></app-side-panel>
